import appGlobalScript from '/home/jenkins/workspace/NTC_panenka-design-system_main/packages/panenka/src/global/scripts/global.ts';
export const globalScripts = appGlobalScript;
